/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChatChannelStatusUpdateRequest
 */
export interface ChatChannelStatusUpdateRequest {
    /**
     * The new status for this chat channel
     * @type {string}
     * @memberof ChatChannelStatusUpdateRequest
     */
    status: ChatChannelStatusUpdateRequestStatusEnum;
}


/**
 * @export
 */
export const ChatChannelStatusUpdateRequestStatusEnum = {
    New: 'NEW',
    Unread: 'UNREAD',
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    Archived: 'ARCHIVED',
    UserEndedChat: 'USER_ENDED_CHAT',
    AgentEndedChat: 'AGENT_ENDED_CHAT',
    InactivityEndedChat: 'INACTIVITY_ENDED_CHAT',
    Deleted: 'DELETED'
} as const;
export type ChatChannelStatusUpdateRequestStatusEnum = typeof ChatChannelStatusUpdateRequestStatusEnum[keyof typeof ChatChannelStatusUpdateRequestStatusEnum];


/**
 * Check if a given object implements the ChatChannelStatusUpdateRequest interface.
 */
export function instanceOfChatChannelStatusUpdateRequest(value: object): value is ChatChannelStatusUpdateRequest {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function ChatChannelStatusUpdateRequestFromJSON(json: any): ChatChannelStatusUpdateRequest {
    return ChatChannelStatusUpdateRequestFromJSONTyped(json, false);
}

export function ChatChannelStatusUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChatChannelStatusUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
    };
}

export function ChatChannelStatusUpdateRequestToJSON(json: any): ChatChannelStatusUpdateRequest {
    return ChatChannelStatusUpdateRequestToJSONTyped(json, false);
}

export function ChatChannelStatusUpdateRequestToJSONTyped(value?: ChatChannelStatusUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
    };
}

